import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Label,
  Input,
} from "reactstrap";
import Select from "react-select";
import { removeLeadingZeros } from "../../../Components/RemoveLeadingZeros/RemoveLeadingZeros";

const PurchaseModal = ({
  isOpen,
  onClose,
  onSave,
  formData,
  selectedProduct,
  productOptions,
  handleProductChange,
  handleTableInputChange,
  touchedModalFields,
  modalErrors,
  handleModalBlur,
  isChildRecordInEditMode,
}) => {
  const handlePurchaseRateChange = (e) => {
    const formattedValue = removeLeadingZeros(e.target.value);
    handleTableInputChange({
      target: {
        name: "purchaseRate",
        value: formattedValue,
      },
    });
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose}>
      <ModalHeader toggle={onClose}>
        {isChildRecordInEditMode ? "Edit Item" : "Add New Item"}
      </ModalHeader>
      <ModalBody>
        <Row className="mb-3">
          <Label>Product</Label>
          <Col>
            <Select
              name="itemId"
              id="itemId"
              value={selectedProduct}
              onChange={handleProductChange}
              options={productOptions}
              isClearable={true}
              className={`${
                touchedModalFields.itemId && modalErrors.itemId
                  ? "is-invalid"
                  : ""
              }`}
              onBlur={() => handleModalBlur("itemId")}
            />
            {touchedModalFields.itemId && modalErrors.itemId && (
              <div className="invalid-feedback">{modalErrors.itemId}</div>
            )}
          </Col>
        </Row>

        <Row className="mb-3">
          <Col sm={12}>
            <Label>Quantity</Label>
            <Input
              type="number"
              name="quantity"
              id="quantity"
              value={formData.activeChildRecord.quantity}
              onChange={(e) => handleTableInputChange(e)}
              className={`form-control ${
                touchedModalFields.quantity && modalErrors.quantity
                  ? "is-invalid"
                  : ""
              }`}
              onBlur={() => handleModalBlur("quantity")}
            />
            {touchedModalFields.quantity && modalErrors.quantity && (
              <div className="invalid-feedback">{modalErrors.quantity}</div>
            )}
          </Col>
        </Row>

        <Row className="mb-3">
          <Label>Purchase Rate</Label>
          <Col>
            <Input
              type="number"
              name="purchaseRate"
              id="purchaseRate"
              value={formData.activeChildRecord.purchaseRate}
              onChange={handlePurchaseRateChange}
              className={`form-control ${
                touchedModalFields.purchaseRate && modalErrors.purchaseRate ? "is-invalid" : ""
              }`}
              onBlur={() => handleModalBlur("purchaseRate")}
            />
            {touchedModalFields.purchaseRate && modalErrors.purchaseRate && (
              <div className="invalid-feedback">{modalErrors.purchaseRate}</div>
            )}
          </Col>
        </Row>

        <Row className="mb-3">
          <Label>Manufacturing Date</Label>
          <Col>
            <Input
              type="date"
              name="mfgDate"
              id="mfgDate"
              value={formData.activeChildRecord.mfgDate || ""}
              onChange={(e) => handleTableInputChange(e)}
              className={`form-control ${
                touchedModalFields.mfgDate && modalErrors.mfgDate
                  ? "is-invalid"
                  : ""
              }`}
            />
          </Col>
        </Row>

        <Row className="mb-3">
          <Label>Expiry Date</Label>
          <Col>
            <Input
              type="date"
              name="expDate"
              id="expDate"
              value={formData.activeChildRecord.expDate || ""}
              onChange={(e) => handleTableInputChange(e)}
              className={`form-control ${
                touchedModalFields.expDate && modalErrors.expDate
                  ? "is-invalid"
                  : ""
              }`}
            />
          </Col>
        </Row>

        <Row className="mb-3">
          <Label>Batch No.</Label>
          <Col>
            <Input
              type="text"
              name="batchNo"
              id="batchNo"
              value={formData.activeChildRecord.batchNo || ""}
              onChange={(e) => handleTableInputChange(e)}
            
            />
       
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="success" onClick={onSave}>
          Save
        </Button>{" "}
        <Button color="danger" onClick={onClose}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PurchaseModal;
